import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Form as BsForm, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import assignCode from '../../assets/Images/code.svg';
import assignGroup from '../../assets/Images/group.svg';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  GroupDefaultSortColumnOrder,
  GroupFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import { isOperationPermittedRoleBase } from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IUpdateGroupSetting } from '../../models/forms/IAddUpdateGroupSetting';
import IPageInfo, { IOption, IPageLimitInfo } from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IGroupFilter } from '../../models/IGroupFilter';
import LoaderButton from '../../shared-components/button/loader-button';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  LeftArrowMove,
  RefreshIcon,
  RightArrowMove,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditCode from './components/add-edit-code';
import AddEditGroupSetting from './components/add-edit-group-setting';
import FilterComponent from './components/filter';
import GroupSettingDetails from './group-setting-details';
import './group-setting.css';
import AddEditGroupCodePopupHOC from './hoc/add-edit-group-code-popup-hoc';
import AddEditGroupSettingPopupHOC from './hoc/add-edit-group-setting-popup-hoc';

const GroupSetting = (props: any) => {
  const { preferencesStore, groupSettingStore } = useStore();

  const {
    GetGroupSettingListService,
    allGroupSettings,
    getAllGroupSettingState,
    groupSettingList,
    deleteGroupSettingState,
    resetGroupSettingDetail,
    DeleteGroupSettingService,
    resetDeleteGroupSetting,
    addUpdateGroupSettingState,
    resetAddUpdateGroupSettingState,
    groupSettingState,
    allGroupOptions,
    GetAllGroupSettingService,
    GetGroupSettingByNameService,
    groupsByNameList,
    getGroupSettingByNameState,
    resetGetAllGroupSettingState,
    UpdateGroupSettingService,
    updateGroupSettingState,
    resetUpdateGroupSettingState,
    getAllGroupNameSettingState,
    addGroupCodeState,
    resetAddGroupCodeState,
    resetGroupSettingByNameState,
    isGroupActive,
  } = groupSettingStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allGroupOptionsData = allGroupOptions;

  enum PartitionEnum {
    left,
    right,
  }

  const [allGroupSettingsListData, setAllGroupSettingsListData] = useState<
    any[]
  >([]);
  const [selectedGroupSettingDetails, setSelectedGroupSettingDetails] =
    useState<any[]>([]);
  const MAX_RECORDS_LENGTH = 16;
  const [rightSelectedData, setRightSelectedData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedCodeIds, setSelectedCodeIds] = useState<any[]>([]);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [showGroupItems, setShowGroupItems] = useState(false);
  const [isGroupSelected, setIsGroupSelected] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [selectedRightIds, setSelecteRightIds] = useState<any[]>([]);
  const [filterObj, setFilterObj] = useState<IGroupFilter>(
    GroupFilterInitialState
  );
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    GroupDefaultSortColumnOrder
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const [groupName, setGroupName] = useState('');

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const createQueryString = (filter: IGroupFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const getGroupSettingsServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetGroupSettingListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    } else {
      GetGroupSettingListService(
        1,
        pageLimitInfo.pageLimit,
        Number(getTenantIdFromLocalStorage()),
        encodeURIComponent(filterQuery)
      );
    }
  };

  function initState() {
    getGroupSettingsServiceHandler();
    setIsGroupSelected(false);
    setShowGroupItems(false);
  }

  useEffect(() => {
    getGroupSettingsServiceHandler();
    setSelectedGroupSettingDetails([]);
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: groupSettingList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [groupSettingList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      const filter = createQueryString({
        ...filterObj,
        IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
      });
      getGroupSettingsServiceHandler(filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      const filter = createQueryString({
        ...filterObj,
        IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
      });
      getGroupSettingsServiceHandler(filter);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getGroupSettingsServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (
      selectedIds.length + selectedGroupSettingDetails.length >
      MAX_RECORDS_LENGTH
    ) {
      toast.error(formatMessage('max_records_allowed'));
    }

    if (
      isGroupSelected &&
      selectedIds.length > 0 &&
      selectedIds.length + selectedGroupSettingDetails.length ===
        MAX_RECORDS_LENGTH
    ) {
      toast.error(formatMessage('max_records_allowed'));
    }

    if (selectedCodeIds.length > selectedIds.length) {
      toast.error(formatMessage('group_already_assigned'));
    }
  }, [selectedIds, selectedCodeIds]);

  useEffect(() => {
    if (updateGroupSettingState.success) {
      toast.success(formatMessage('updated_success'));
      resetUpdateGroupSettingState();
      initState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateGroupSettingState.success]);

  useEffect(() => {
    if (addUpdateGroupSettingState.success) {
      setSelectedCodeIds([]);
      setSelectedRows([]);
      resetAddUpdateGroupSettingState();
      getGroupSettingsServiceHandler();
      setSelectedIds([]);
      setSelectedCodeIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateGroupSettingState.success]);

  useEffect(() => {
    if (addUpdateGroupSettingState.error) {
      toast.error(formatMessage(addUpdateGroupSettingState.error));
      resetAddUpdateGroupSettingState();
      initState();
    }
  }, [addUpdateGroupSettingState.error]);

  useEffect(() => {
    if (addGroupCodeState.success) {
      setSelectedCodeIds([]);
      setSelectedRows([]);
      resetAddGroupCodeState();
      getGroupSettingsServiceHandler();
      setSelectedIds([]);
      setSelectedCodeIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addGroupCodeState.success]);

  useEffect(() => {
    if (addGroupCodeState.error) {
      toast.error(formatMessage(addGroupCodeState.error));
      resetAddGroupCodeState();
      initState();
    }
  }, [addGroupCodeState.error]);

  useEffect(() => {
    if (deleteGroupSettingState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteGroupSetting();
      getGroupSettingsServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteGroupSettingState.success]);

  useEffect(() => {
    if (getAllGroupSettingState.success) {
      setAllGroupSettingsListData(allGroupSettings);
      resetGetAllGroupSettingState();
    }
  }, [getAllGroupSettingState.success]);

  useEffect(() => {
    if (getGroupSettingByNameState.success) {
      setAllGroupSettingsListData(
        !isGroupSelected
          ? allGroupSettingsListData
          : allGroupSettingsListData.filter((item) => item?.Group.length === 0)
      );
      setSelectedGroupSettingDetails([...groupsByNameList]);
      resetGroupSettingByNameState();
    }
  }, [getGroupSettingByNameState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    if (row.Group.length > 0) {
      className += 'highlighted-row';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    if ((e.target as HTMLElement).tagName === 'INPUT') {
      e.stopPropagation();
      return;
    }
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({
      ...filterObj,
      IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
    });
    getGroupSettingsServiceHandler(filter);
    setSelectedCodeIds([]);
    setSelectedRows([]);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteGroupSettingService(selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetGroupSettingDetail();
    props.deletePopupToggleHandler();
  };

  const openAddGroupSettingHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetGroupSettingDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  const openAddGroupCodeHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    props.addGroupCodeToggleHandler();
  };

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'ProductId':
        return 'product_id';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'Katashiki':
        return 'katashiki';
      case 'Kishu':
        return 'kishu';
      case 'IsAssigned':
        return 'is_assigned';
      default:
        return 'customer_due_date';
    }
  }

  const handleTableChange = (type: any, newState: any) => {
    if(newState.sortField !== columSortOrder.dataField || newState.sortOrder !== columSortOrder.order || !isGroupSelected){
    // if (!isGroupSelected) {
      resetGetAllGroupSettingState();
        setColumnSortOrder({
          ...columSortOrder,
          dataField: newState.sortField,
          order: newState.sortOrder,
        });
        const filter = createQueryString({
          ...filterObj,
          Column: newState.sortField,
          Order: newState.sortOrder,
          IsAssigned: !showGroupItems ? '' : isGroupSelected ? 'false' : 'true',
        });
        getGroupSettingsServiceHandler(filter);
      // }
    }
  };

  // useEffect(() => {
  //   const filter = createQueryString({
  //     ...filterObj,
  //     Column: columSortOrder.dataField,
  //     Order: columSortOrder.order,
  //   });

  //   getGroupSettingsServiceHandler(filter);
  // }, [columSortOrder]);

  const filterHandler = (object: IGroupFilter) => {
    const filter = createQueryString({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    getGroupSettingsServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    props.filterPopupToggleHandler();
    closePanelHandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: IGroupFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getGroupSettingsServiceHandler(filter);
      closePanelHandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();

    // select all checkbox remain checked when we clear the filter.
    // setSelectedCodeIds([]);
    setSelectedRows([]);
  };
  // const handleSelectAllLeft = (event) => {
  //   setAllGroupSettingsListData((prevData) =>
  //     prevData.map((item) => {
  //       return { ...item, isSelected: event.target.checked };
  //     })
  //   );

  //   setSelectedCodeIds((prev) => {
  //     if (event.target.checked) {
  //       return [...prev, ...allGroupSettingsListData];
  //     } else {
  //       return [];
  //     }
  //   });

  //   setSelectedRows((prevData) =>
  //     event.target.checked
  //       ? allGroupSettingsListData.filter(
  //           (item) => item.Group.length === 0 || showGroupItems
  //         )
  //       : []
  //   );
  // };

  // const handleSelectAllRight = (event) => {
  //   setSelectedGroupSettingDetails((prevData) =>
  //     prevData.map((item) => ({ ...item, isSelected: event.target.checked }))
  //   );

  //   setRightSelectedData((prev) => {
  //     if (event.target.checked) {
  //       return [
  //         ...prev,
  //         ...selectedGroupSettingDetails.map((m) => ({
  //           ...m,
  //           isSelected: event.target.checked,
  //         })),
  //       ];
  //     } else {
  //       return [];
  //     }
  //   });
  // };

  // const handleCheckboxChange = (row: any, event: any) => {
  //   event.stopPropagation();
  //   setAllGroupSettingsListData((prevData) => {
  //     return prevData.map((item) =>
  //       item.TrayId === row.TrayId
  //         ? { ...item, isSelected: event.target.checked }
  //         : item
  //     );
  //   });

  //   setSelectedCodeIds((prev) => {
  //     if (event.target.checked) {
  //       return [...prev, row];
  //     } else {
  //       return prev.filter((r) => r.Id !== row.Id);
  //     }
  //   });

  //   if (row.Group.length <= 0 || showGroupItems) {
  //     setSelectedRows((prev) => {
  //       const isAlreadySelected = prev.some((r) => {
  //         return r.Id === row.Id;
  //       });

  //       if (isAlreadySelected) {
  //         return prev.filter((r) => r.Id !== row.Id);
  //       }

  //       return [...prev, row];
  //     });
  //   }
  // };

  // const handleRightCheckboxChange = (row: any, event: any) => {
  //   event.stopPropagation();
  //   setSelectedGroupSettingDetails((prevData) =>
  //     prevData.map((item) =>
  //       item.TrayId === row.TrayId
  //         ? { ...item, isSelected: event.target.checked }
  //         : item
  //     )
  //   );
  //   setRightSelectedData((prev) => {
  //     const isAlreadySelected = prev.some((r) => r.Id === row.Id);

  //     if (isAlreadySelected) {
  //       return prev.filter((r) => r.Id !== row.Id);
  //     }

  //     return [...prev, row];
  //   });
  // };

  const handleGroupSelectionChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    resetGroupSettingByNameState();
    const queryString = createQueryString({
      ...filterObj,
      IsAssigned: e.target.value === 'select_all' ? 'true' : 'false',
    });

    if (e.target.value === 'select_all') {
      setIsGroupSelected(false);
    } else {
      GetGroupSettingByNameService(
        Number(getTenantIdFromLocalStorage()),
        e.target.value
      );
      setIsGroupSelected(true);
      setGroupName(e.target.value);
    }
    getGroupSettingsServiceHandler(queryString);
    resetGetAllGroupSettingState();
  };

  const toggleShowGroup = (e: any) => {
    const queryString = createQueryString({
      ...filterObj,
      IsAssigned: e.target.checked ? 'false' : '',
    });

    setSelectedCodeIds([]);
    setSelectedIds([]);
    setSelectedRows([]);
    setSelectedGroupSettingDetails([]);
    setRightSelectedData([]);
    getGroupSettingsServiceHandler(queryString);

    setShowGroupItems(!showGroupItems);
    setIsGroupSelected(e.target.checked);

    if (e.target.checked) {
      GetAllGroupSettingService(Number(getTenantIdFromLocalStorage()));
    }

    // if (selectedGroup.length > 0) {
    //   GetGroupSettingByNameService(
    //     Number(getTenantIdFromLocalStorage()),
    //     selectedGroup
    //   );
    // }

    //Sometimes the selected group details are not showing so we added this code.
    setSelectedGroupSettingDetails([...groupsByNameList]);
    if(!e.target.checked){
      setSelectedGroupSettingDetails([]);
    }
  };

  // useEffect(() => {
  //   if (selectedGroup.length > 0)
  //     GetGroupSettingByNameService(
  //       Number(getTenantIdFromLocalStorage()),
  //       selectedGroup
  //     );
  // }, [selectedGroup]);

  useEffect(() => {
    if (
      getAllGroupNameSettingState.success &&
      allGroupOptionsData &&
      allGroupOptionsData.length > 0
    ) {
      setSelectedGroup(allGroupOptionsData[0].value);
      GetGroupSettingByNameService(
        Number(getTenantIdFromLocalStorage()),
        allGroupOptionsData[0].value
      );

      //Set the group name
      setGroupName(allGroupOptionsData[0].value);
    }
    // }, [getAllGroupNameSettingState.success]);
  }, [getAllGroupNameSettingState.success, allGroupOptionsData]);

  const getColumns = (partition: PartitionEnum) => [
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerId',
      text: formatMessage('customer_id'),
      classes: 'show-Elipses',
    },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Katashiki1',
      text: formatMessage('katashiki'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('eu_order_no'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo1',
      text: formatMessage('key_info_1'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo2',
      text: formatMessage('key_info_2'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'KeyInfo3',
      text: formatMessage('key_info_3'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'Group',
      text: formatMessage('group'),
      classes: 'show-Elipses',
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      classes: 'show-Elipses',
      sort: true,
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
    {
      dataField: 'PlanedDueDate',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
      hidden: true,
    },
    {
      dataField: 'Code',
      text: formatMessage('code'),
      classes: 'show-Elipses',
      title: (cell) => (cell.length > 10 ? cell : undefined),
    },
  ];

  const moveSelectedToRight = () => {
    const moveableRows = allGroupSettingsListData.filter((item) =>
      selectedCodeIds.includes(item.Id)
    );

    setSelectedGroupSettingDetails((prev) => [
      ...prev,
      ...moveableRows.map((m) => ({ ...m, isSelected: false })),
    ]);

    setAllGroupSettingsListData((prev) =>
      prev.filter((item) => !selectedCodeIds.includes(item.Id))
    );

    setSelectedIds([]);
    setSelectedCodeIds([]);
  };

  const moveSelectedToLeft = () => {
    const moveableRows = selectedGroupSettingDetails.filter((item) =>
      selectedRightIds.includes(item.Id)
    );

    const updatedMoveableRows = moveableRows.map((m) => ({
      ...m,
      Group: '',
      isSelected: false,
    }));

    setAllGroupSettingsListData((prev) => [...prev, ...updatedMoveableRows]);

    setSelectedGroupSettingDetails((prev) =>
      prev.filter((item) => !selectedRightIds.includes(item.Id))
    );

    setSelecteRightIds([]);
  };

  // Build nonSelectable dynamically
  const nonSelectableIds = allGroupSettingsListData
    .filter((row) => {
      const isGroupAssigned = row.Group.length > 0;
      const isSelected = selectedIds.includes(row.Id);
      const selectionLimitReached =
        selectedIds.length + selectedGroupSettingDetails.length >=
        MAX_RECORDS_LENGTH;

      // Disable if group is assigned or selection limit reached and it's not already selected
      return selectionLimitReached && !isSelected; // isGroupAssigned || (selectionLimitReached && !isSelected);
    })
    .map((row) => row.Id);

  const selectRowLeft = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedCodeIds,
    hideSelectColumn: isGroupActive && showGroupItems,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    // selectable: (row) => {
    //   const isGroupFree = row.Group.length === 0;
    //   const isAlreadySelected = selectedIds.includes(row.Id);
    //   const underLimit = selectedIds.length < MAX_RECORDS_LENGTH;
    //   return true;
    // },
    nonSelectable: isGroupSelected ? nonSelectableIds : [],
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedCodeIds((prev) => [...prev, row.Id]);
      } else {
        setSelectedCodeIds((prev) => prev.filter((id) => id !== row.Id));
      }
      if (row.Group.length === 0) {
        if (isSelect) {
          setSelectedIds((prev) => [...prev, row.Id]);
        } else {
          setSelectedIds((prev) => prev.filter((id) => id !== row.Id));
        }
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        setSelectedCodeIds(rows.map((item) => item.Id));
      } else {
        setSelectedCodeIds([]);
      }
      const selectableRows = rows.filter((row) => row.Group.length === 0);
      if (isSelect) {
        setSelectedIds(selectableRows.map((row) => row.Id));
      } else {
        setSelectedIds([]);
      }
    },
  };

  const selectRowRight = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: isGroupActive,
    selected: selectedRightIds,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    nonSelectable: isGroupActive
      ? selectedGroupSettingDetails.map((row) => row.Id)
      : [],
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelecteRightIds((prev) => [...prev, row.Id]);
      } else {
        setSelecteRightIds((prev) =>
          prev.filter((TrayId) => TrayId !== row.Id)
        );
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((row) => row.Id);
        setSelecteRightIds(allIds);
      } else {
        setSelecteRightIds([]);
      }
    },
  };

  return (
    <>
      {props.showAddGroupSettingPopup && (
        <AddEditGroupSetting
          id={selectedId}
          modalClosed={props.addToggleHandler}
          selectedRows={selectedIds}
        />
      )}
      {props.showAddGroupCodePopup && (
        <AddEditCode
          id={selectedId}
          modalClosed={props.addGroupCodeToggleHandler}
          selectedAssignedRows={selectedCodeIds}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_group_setting"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_group_setting_confirm"
          isLoading={deleteGroupSettingState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-4 col-md-6 col-sm-6 col-xl-4"
            label="group_management"
          />
          <div className="col-lg-8 col-md-6 col-sm-6 col-xl-8">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={isGroupSelected}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li
                title={formatMessage('refresh')}
                className={`${showGroupItems ? 'd-none' : ''}`}
              >
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li
                title={`${formatMessage('show_groups')}`}
                className="d-flex align-items-center g-2 ms-4 ps-1 show-group"
              >
                <BsForm.Check
                  type="switch"
                  id="custom-switch"
                  className="btn"
                  checked={showGroupItems}
                  readOnly
                  onClick={(e: any) => toggleShowGroup(e)}
                />
                <p className="auto-refresh text-white">
                  {formatMessage('show_groups')}
                </p>
              </li>
              {showGroupItems && (
                <li className="select-group">
                  <select
                    className="custom-select form-control"
                    value={selectedGroup}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      setSelectedGroup(e.target.value);
                      handleGroupSelectionChange(e);
                    }}
                    disabled={
                      allGroupOptionsData.length === 0 ||
                      allGroupOptions.filter(
                        (group) => group.disabled === false
                      ).length === 0
                    }
                  >
                    {allGroupOptionsData.length !== 0 &&
                    allGroupOptions.filter((group) => group.disabled === false)
                      .length > 0 ? (
                      allGroupOptionsData.map(
                        (data: IOption, index: number) => (
                          <option
                            key={data.value}
                            value={data.value}
                            disabled={data.disabled}
                            className={`${data.disabled ? 'disabled-option' : ''}`}
                          >
                            {index == 0
                              ? formatMessage(data.value)
                              : data.value}
                          </option>
                        )
                      )
                    ) : (
                      <option
                        value={selectedGroup}
                        disabled={true}
                      >
                        {formatMessage('no_group')}
                      </option>
                    )}
                  </select>
                </li>
              )}
              {isOperationPermittedRoleBase(
                ModuleType.GroupManagement,
                'Add'
              ) &&
                !showGroupItems && (
                  <li
                    title={formatMessage('assign_group')}
                    className="select-group"
                  >
                    <a
                      className={`btn btn-primary btn-blue ${selectedIds.length >= 1 && selectedIds.length <= MAX_RECORDS_LENGTH && selectedIds.length > 0 && selectedIds.length === selectedCodeIds.length ? '' : 'disabled'} `}
                      data-toggle="modal"
                      data-testid="modalbtn"
                      data-target="#addUser"
                      onClick={(event: any) =>
                        openAddGroupSettingHandler({ Id: -1 }, event)
                      }
                    >
                      <img
                        src={assignGroup}
                        alt=""
                        className="assignCode me-2"
                      />
                      <FormattedMessage id="assign_group" />
                    </a>
                  </li>
                )}
              {!showGroupItems && (
                <li
                  title={formatMessage('add_group_code')}
                  className="select-group"
                >
                  <a
                    className={`btn btn-secondary ${selectedCodeIds.length > 0 ? '' : 'disabled'} `}
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddGroupCodeHandler({ Id: -1 }, event)
                    }
                  >
                    <img
                      src={assignCode}
                      alt=""
                      className="assignCode me-2"
                    />
                    <FormattedMessage id="add_group_code" />
                  </a>
                </li>
              )}
              <li>
                {isGroupSelected && (
                  <div>
                    <LoaderButton
                      className="btn-secondary save-group"
                      text="save"
                      onClick={(event: any) => {
                        var updateObj: IUpdateGroupSetting = {
                          GroupId: selectedGroupSettingDetails
                            .map((item) => item.Id)
                            .join(','),
                          TenantId: Number(getTenantIdFromLocalStorage()),
                          GroupName: groupName,
                        };
                        UpdateGroupSettingService(updateObj);
                        setSelectedCodeIds([]);
                        setSelectedIds([]);
                      }}
                      disabled={isGroupActive || allGroupOptions.length === 0}
                    />
                  </div>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllGroupSettingState.inProgress ||
            groupSettingState.inProgress ||
            deleteGroupSettingState.inProgress ||
            getGroupSettingByNameState.inProgress ||
            addUpdateGroupSettingState.inProgress) && (
            <FormLoader
              loading={
                getAllGroupSettingState.inProgress ||
                groupSettingState.inProgress ||
                deleteGroupSettingState.inProgress ||
                getGroupSettingByNameState.inProgress ||
                addUpdateGroupSettingState.inProgress
              }
            />
          )}
          {
            <div className="row">
              <div
                className={`${isGroupSelected === true && allGroupOptionsData.length > 0 && allGroupOptions.filter((group) => group.disabled === false).length > 0 ? 'col-6 group-table' : 'col-12'}`}
              >
                {allGroupSettingsListData &&
                allGroupSettingsListData.length > 0 ? (
                  <div>
                    {allGroupSettingsListData &&
                      allGroupSettingsListData.length > 0 && (
                        <>
                          <div className="tableDesign row-eq-height tableDevices p-3 changingPanel ">
                            <div
                              className="table-responsive"
                              data-testid="table"
                            >
                              {allGroupSettingsListData && (
                                <Grid
                                  data={allGroupSettingsListData}
                                  columns={getColumns(PartitionEnum.left)}
                                  keyField="Id"
                                  loading={false}
                                  rowClasses={rowClassFormat}
                                  hover={true}
                                  sort={columSortOrder}
                                  selectRow={selectRowLeft}
                                  remote={{ sort: true }}
                                  onTableChange={handleTableChange}
                                />
                              )}
                            </div>
                          </div>

                          {allGroupSettingsListData.length > 0 ? (
                            <div className="row no-gutters p-3 pt-0 tableFooter">
                              <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                                <FormattedMessage id="show" />
                                <select
                                  data-testid="pageSelect"
                                  className="pageLimit"
                                  onChange={onPageLimitChanged}
                                  value={pageLimitInfo.pageLimit}
                                >
                                  {pageLimitOptions.map((option: any) => (
                                    <option
                                      key={option}
                                      value={option}
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                                <Pagination
                                  isRefreshPage={false}
                                  totalPages={pageInfo.totalPages}
                                  pageLimit={pageLimitInfo.pageLimit}
                                  onPageChanged={onPageChanged}
                                  disablePagination={disablePagination}
                                  setIsRefreshPage={setIsRefreshPage}
                                  currentPage={pageInfo.currentPage}
                                  totalRecords={
                                    groupSettingList.PagingDetails.TotalRecords
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                  </div>
                ) : (
                  <div className="message">
                    <div className="message-area">
                      <div className="no-data-img text-center">
                        <svg
                          clipRule="evenodd"
                          fillRule="evenodd"
                          height="100"
                          strokeLinejoin="round"
                          strokeMiterlimit="2"
                          viewBox="0 0 64 64"
                          width="100"
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_7486747"
                        >
                          <g id="Exp-2.-F">
                            <path
                              d="m52 35.617h-40v18.512c0 .883.579 1.662 1.425 1.916 4.019 1.205 15.321 4.596 18 5.4.375.112.775.112 1.15 0 2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
                              fill="#cadcf0"
                            ></path>
                            <path
                              d="m52 35.617h-20s-.194 25.912 0 25.912.387-.028.575-.084c2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
                              fill="#a4bbdb"
                            ></path>
                            <path
                              d="m32 42.106-20-6.489s-3.507 5.2-5.075 7.524c-.176.261-.219.588-.117.885.103.297.338.528.637.626 3.799 1.234 15.045 4.888 17.995 5.846.423.138.887-.021 1.137-.39 1.341-1.979 5.423-8.002 5.423-8.002z"
                              fill="#e9f3fc"
                            ></path>
                            <path
                              d="m52 35.617-20 6.489s4.082 6.023 5.423 8.002c.25.369.714.528 1.137.39 2.95-.958 14.196-4.612 17.995-5.846.299-.098.534-.329.637-.626.102-.297.059-.624-.117-.885-1.568-2.324-5.075-7.524-5.075-7.524z"
                              fill="#e9f3fc"
                            ></path>
                            <path
                              d="m27.159 21.986c-.25-.367-.713-.526-1.136-.388-2.948.957-14.197 4.612-17.996 5.847-.299.097-.535.328-.637.625s-.059.625.117.885c1.444 2.142 4.493 6.662 4.493 6.662l20-6.511s-3.592-5.283-4.841-7.12z"
                              fill="#cadcf0"
                            ></path>
                            <path
                              d="m56.493 28.955c.176-.26.219-.588.117-.885s-.338-.528-.637-.625c-3.799-1.235-15.048-4.89-17.996-5.847-.423-.138-.886.021-1.136.388-1.249 1.837-4.841 7.12-4.841 7.12l20 6.511s3.049-4.52 4.493-6.662z"
                              fill="#e9f3fc"
                            ></path>
                            <path
                              d="m52 35.617-20-6.511-20 6.511 20 6.489z"
                              fill="#cadcf0"
                            ></path>
                            <path
                              d="m32 42.106v-13l-20 6.511z"
                              fill="#a4bbdb"
                            ></path>
                            <g fill="#347bfa">
                              <path d="m27.982 31.978c-.416-.272-.791-.563-1.124-.868-.406-.373-1.039-.346-1.413.061-.373.406-.346 1.039.061 1.412.409.376.87.734 1.382 1.069.462.302 1.082.172 1.384-.29s.172-1.082-.29-1.384z"></path>
                              <path d="m24.866 28.906c-.297-.403-.548-.808-.754-1.213-.25-.492-.853-.688-1.345-.438s-.688.853-.438 1.345c.254.498.562.997.927 1.492.327.444.953.539 1.398.212.444-.328.539-.954.212-1.398z"></path>
                              <path d="m23.404 24.825c.01-.403.069-.794.177-1.169.152-.53-.155-1.085-.686-1.237-.53-.152-1.085.155-1.237.686-.153.536-.239 1.095-.254 1.67-.013.552.423 1.011.975 1.024.552.014 1.011-.422 1.025-.974z"></path>
                              <path d="m24.942 21.485c.257-.238.545-.458.86-.657.467-.295.607-.913.313-1.379-.295-.467-.913-.607-1.38-.313-.423.267-.807.562-1.152.882-.405.375-.429 1.008-.054 1.413s1.008.429 1.413.054z"></path>
                              <path d="m28.661 19.76c.503-.093 1.036-.153 1.598-.176.552-.024.98-.491.957-1.042s-.49-.98-1.042-.957c-.66.028-1.286.099-1.877.208-.542.101-.902.623-.801 1.165.1.543.622.902 1.165.802z"></path>
                              <path d="m33.873 19.701c.853.01 1.647-.02 2.384-.085.55-.049.957-.535.908-1.085-.049-.549-.535-.956-1.085-.907-.675.059-1.402.087-2.184.077-.552-.006-1.005.437-1.011.988-.007.552.436 1.006.988 1.012z"></path>
                              <path d="m39.544 19.003c.99-.303 1.826-.691 2.526-1.136.465-.297.603-.915.306-1.381-.296-.465-.915-.603-1.381-.306-.563.358-1.238.666-2.036.91-.527.162-.825.721-.663 1.249.161.528.721.825 1.248.664z"></path>
                              <path d="m44.634 15.068c.472-.976.653-2.008.607-3.003-.026-.552-.495-.978-1.046-.952s-.978.494-.952 1.045c.032.676-.09 1.377-.41 2.04-.24.497-.032 1.096.465 1.336s1.096.031 1.336-.466z"></path>
                              <path d="m43.997 8.529c-.729-.985-1.718-1.671-2.796-1.892-.541-.11-1.07.238-1.181.779-.11.541.239 1.07.779 1.181.622.127 1.17.554 1.591 1.123.329.443.956.536 1.399.208.444-.329.537-.956.208-1.399z"></path>
                            </g>
                            <path
                              d="m30.933 6.831c1.082-6.127 10.459-5.731 5 0z"
                              fill="#cadcf0"
                            ></path>
                            <path
                              d="m30.933 8.383c1.082 6.126 10.459 5.731 5 0z"
                              fill="#cadcf0"
                            ></path>
                            <path
                              d="m30.843 8.617h6.696c.552 0 1-.448 1-1s-.448-1-1-1h-6.696c-.551 0-1 .448-1 1s.449 1 1 1z"
                              fill="#347bfa"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="no-group-display">
                        <h4 className="fw-bold display-6">
                          {' '}
                          <FormattedMessage id="no_data" />
                        </h4>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {isGroupSelected &&
                allGroupOptionsData.length > 0 &&
                allGroupOptions.filter((group) => group.disabled === false)
                  .length > 0 && (
                  <div className="move-arrow">
                    <Button
                      onClick={moveSelectedToRight}
                      disabled={
                        isGroupActive
                          ? isGroupActive
                          : selectedIds.length +
                              selectedGroupSettingDetails.length >
                              MAX_RECORDS_LENGTH || selectedIds.length === 0
                      }
                    >
                      <RightArrowMove />
                    </Button>
                    <Button
                      onClick={moveSelectedToLeft}
                      disabled={
                        isGroupActive
                          ? isGroupActive
                          : selectedRightIds.length === 0
                      }
                    >
                      <LeftArrowMove />
                    </Button>
                  </div>
                )}

              {isGroupSelected &&
                allGroupOptionsData.length > 0 &&
                allGroupOptions.filter((group) => group.disabled === false)
                  .length > 0 && (
                  <div
                    className={`${isGroupSelected === true && allGroupOptionsData.length > 0 && allGroupOptions.filter((group) => group.disabled === false).length > 0 ? 'col-6' : 'col-12'}`}
                  >
                    {selectedGroupSettingDetails &&
                    selectedGroupSettingDetails.length > 0 ? (
                      <>
                        <div className="tableDesign row-eq-height tableDevices p-3 changingPanel group-table">
                          <div
                            className="table-responsive"
                            data-testid="table"
                          >
                            {selectedGroupSettingDetails && (
                              <Grid
                                data={selectedGroupSettingDetails}
                                columns={getColumns(PartitionEnum.right)}
                                keyField="Id"
                                loading={false}
                                rowClasses={rowClassFormat}
                                hover={true}
                                selectRow={selectRowRight}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="message">
                        <div className="message-area">
                          <div className="no-data-img text-center">
                            <svg
                              clipRule="evenodd"
                              fillRule="evenodd"
                              height="100"
                              strokeLinejoin="round"
                              strokeMiterlimit="2"
                              viewBox="0 0 64 64"
                              width="100"
                              xmlns="http://www.w3.org/2000/svg"
                              id="fi_7486747"
                            >
                              <g id="Exp-2.-F">
                                <path
                                  d="m52 35.617h-40v18.512c0 .883.579 1.662 1.425 1.916 4.019 1.205 15.321 4.596 18 5.4.375.112.775.112 1.15 0 2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
                                  fill="#cadcf0"
                                ></path>
                                <path
                                  d="m52 35.617h-20s-.194 25.912 0 25.912.387-.028.575-.084c2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
                                  fill="#a4bbdb"
                                ></path>
                                <path
                                  d="m32 42.106-20-6.489s-3.507 5.2-5.075 7.524c-.176.261-.219.588-.117.885.103.297.338.528.637.626 3.799 1.234 15.045 4.888 17.995 5.846.423.138.887-.021 1.137-.39 1.341-1.979 5.423-8.002 5.423-8.002z"
                                  fill="#e9f3fc"
                                ></path>
                                <path
                                  d="m52 35.617-20 6.489s4.082 6.023 5.423 8.002c.25.369.714.528 1.137.39 2.95-.958 14.196-4.612 17.995-5.846.299-.098.534-.329.637-.626.102-.297.059-.624-.117-.885-1.568-2.324-5.075-7.524-5.075-7.524z"
                                  fill="#e9f3fc"
                                ></path>
                                <path
                                  d="m27.159 21.986c-.25-.367-.713-.526-1.136-.388-2.948.957-14.197 4.612-17.996 5.847-.299.097-.535.328-.637.625s-.059.625.117.885c1.444 2.142 4.493 6.662 4.493 6.662l20-6.511s-3.592-5.283-4.841-7.12z"
                                  fill="#cadcf0"
                                ></path>
                                <path
                                  d="m56.493 28.955c.176-.26.219-.588.117-.885s-.338-.528-.637-.625c-3.799-1.235-15.048-4.89-17.996-5.847-.423-.138-.886.021-1.136.388-1.249 1.837-4.841 7.12-4.841 7.12l20 6.511s3.049-4.52 4.493-6.662z"
                                  fill="#e9f3fc"
                                ></path>
                                <path
                                  d="m52 35.617-20-6.511-20 6.511 20 6.489z"
                                  fill="#cadcf0"
                                ></path>
                                <path
                                  d="m32 42.106v-13l-20 6.511z"
                                  fill="#a4bbdb"
                                ></path>
                                <g fill="#347bfa">
                                  <path d="m27.982 31.978c-.416-.272-.791-.563-1.124-.868-.406-.373-1.039-.346-1.413.061-.373.406-.346 1.039.061 1.412.409.376.87.734 1.382 1.069.462.302 1.082.172 1.384-.29s.172-1.082-.29-1.384z"></path>
                                  <path d="m24.866 28.906c-.297-.403-.548-.808-.754-1.213-.25-.492-.853-.688-1.345-.438s-.688.853-.438 1.345c.254.498.562.997.927 1.492.327.444.953.539 1.398.212.444-.328.539-.954.212-1.398z"></path>
                                  <path d="m23.404 24.825c.01-.403.069-.794.177-1.169.152-.53-.155-1.085-.686-1.237-.53-.152-1.085.155-1.237.686-.153.536-.239 1.095-.254 1.67-.013.552.423 1.011.975 1.024.552.014 1.011-.422 1.025-.974z"></path>
                                  <path d="m24.942 21.485c.257-.238.545-.458.86-.657.467-.295.607-.913.313-1.379-.295-.467-.913-.607-1.38-.313-.423.267-.807.562-1.152.882-.405.375-.429 1.008-.054 1.413s1.008.429 1.413.054z"></path>
                                  <path d="m28.661 19.76c.503-.093 1.036-.153 1.598-.176.552-.024.98-.491.957-1.042s-.49-.98-1.042-.957c-.66.028-1.286.099-1.877.208-.542.101-.902.623-.801 1.165.1.543.622.902 1.165.802z"></path>
                                  <path d="m33.873 19.701c.853.01 1.647-.02 2.384-.085.55-.049.957-.535.908-1.085-.049-.549-.535-.956-1.085-.907-.675.059-1.402.087-2.184.077-.552-.006-1.005.437-1.011.988-.007.552.436 1.006.988 1.012z"></path>
                                  <path d="m39.544 19.003c.99-.303 1.826-.691 2.526-1.136.465-.297.603-.915.306-1.381-.296-.465-.915-.603-1.381-.306-.563.358-1.238.666-2.036.91-.527.162-.825.721-.663 1.249.161.528.721.825 1.248.664z"></path>
                                  <path d="m44.634 15.068c.472-.976.653-2.008.607-3.003-.026-.552-.495-.978-1.046-.952s-.978.494-.952 1.045c.032.676-.09 1.377-.41 2.04-.24.497-.032 1.096.465 1.336s1.096.031 1.336-.466z"></path>
                                  <path d="m43.997 8.529c-.729-.985-1.718-1.671-2.796-1.892-.541-.11-1.07.238-1.181.779-.11.541.239 1.07.779 1.181.622.127 1.17.554 1.591 1.123.329.443.956.536 1.399.208.444-.329.537-.956.208-1.399z"></path>
                                </g>
                                <path
                                  d="m30.933 6.831c1.082-6.127 10.459-5.731 5 0z"
                                  fill="#cadcf0"
                                ></path>
                                <path
                                  d="m30.933 8.383c1.082 6.126 10.459 5.731 5 0z"
                                  fill="#cadcf0"
                                ></path>
                                <path
                                  d="m30.843 8.617h6.696c.552 0 1-.448 1-1s-.448-1-1-1h-6.696c-.551 0-1 .448-1 1s.449 1 1 1z"
                                  fill="#347bfa"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <div className="no-group-display">
                            <h3 className="fw-bold display-6">
                              {' '}
                              <FormattedMessage id="no_data" />
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          }
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.TrayId}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <GroupSettingDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddEditGroupCodePopupHOC(
    AddEditGroupSettingPopupHOC(DeletePopupHOC(observer(GroupSetting)))
  )
);
